"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRTL = exports.llPrecedence = exports.ll = exports.pseudoll = exports.llMissing = exports.loadLanguageJSON = exports.LocalizedLanguage = exports.defaultLanguageData = exports.defaultLanguageId = exports.languageData = exports.languages = void 0;
const _ = __importStar(require("lodash"));
/* eslint-disable no-console */
__exportStar(require("./LLContext"), exports);
exports.languages = {};
exports.languageData = {};
exports.defaultLanguageId = "en-us", exports.defaultLanguageData = exports.languageData[exports.defaultLanguageId];
exports.LocalizedLanguage = {};
exports.loadLanguageJSON = (languageId, data, parentLanguageId) => {
    languageId =
        (languageId && languageId.toLowerCase()) ||
            exports.defaultLanguageId.toLowerCase();
    let language = {};
    if (data) {
        exports.languageData[languageId] = data;
    }
    if (parentLanguageId) {
        _.assign(language, exports.languageData[parentLanguageId], exports.languageData[languageId]);
    }
    else {
        _.assign(language, exports.languageData[languageId]);
    }
    const missingKeys = _.difference(_.keys(exports.defaultLanguageData), _.keys(language));
    if (missingKeys &&
        missingKeys.length > 0 &&
        process.env.NODE_ENV !== "test") {
        console.log("Missing Keys", missingKeys);
    }
    exports.LocalizedLanguage = language;
    exports.languages[languageId] = language;
    return language;
};
function llMissing(str) {
    console.warn("Add a localized language entry for the string: " + str);
    // if (settings.showDebugMessages) {
    //    alert({
    //       type: "info",
    //       header: "Localized Language Missing",
    //       message: "Add a localized language entry for the string: " + str,
    //       wait: 10000
    //    });
    // }
}
exports.llMissing = llMissing;
function pseudoll(value) {
    var lower = "áβçδèƒϱλïJƙℓ₥ñôƥ9řƨƭúƲωж¥ƺ"; // spellcheck-off
    var upper = "ÂßÇÐÉFGHÌJK£MNÓÞQR§TÛVWXÝZ";
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
        var code = value.charCodeAt(i);
        if (code >= 65 && code <= 90) {
            newValue += upper[code - 65];
        }
        else if (code >= 97 && code <= 122) {
            newValue += lower[code - 97];
        }
        else {
            newValue += value[i];
        }
    }
    return newValue;
}
exports.pseudoll = pseudoll;
exports.ll = (args) => {
    if (typeof args === "string") {
        args = { key: args };
    }
    const { key, languageId, noMessage, showAlert, variables } = args;
    if (languageId == "pseudoLL") {
        exports.languages.pseudoLL = {};
    }
    const lsLanguage = JSON.parse(localStorage.getItem("userPreferences") || "{}");
    const langKey = (languageId && languageId.toLowerCase()) ||
        (lsLanguage && lsLanguage.Language) ||
        exports.defaultLanguageId.toLowerCase();
    const language = exports.languages[langKey];
    if (!key) {
        return "";
    }
    var result = noMessage ? "" : `Not Localized String (${key})`, localizedString = language ? language[key] : "No Language Data";
    if (localStorage.pseudoll === "true" || languageId === "pseudoLL") {
        localizedString = pseudoll(key);
    }
    else if (key.indexOf(".") != -1 && !localizedString) {
        var lastIndex = key.lastIndexOf("."), newString = key.substr(lastIndex + 1);
        localizedString = language[newString];
    }
    if (localizedString) {
        result = localizedString;
    }
    else if (!noMessage && showAlert != false) {
        llMissing(key);
    }
    if (variables && variables.length > 0) {
        variables.forEach((value, index) => {
            result = result.replaceAll(`{${index}}`, value);
        });
    }
    result = result.replace(/<br ?\/?>/g, "\n");
    return result || "";
};
const showLLPrecedenceWarnings = false;
/**
 * Localizes a string by searching the provided array for an entry in localized language
 * @param {object} args
 * @param {string} args.precedence An array of localized language keys to try
 * @param {string} args.defaultString The string to return if no localized language is found
 * @param {object} [args.localizedLanguage] Object containing localized language keys and values
 * @param {boolean} [args.showLocalizationWarnings] Whether or not to show warnings when localization fails
 * @returns {string} The first value found in localized language, or the defaultString if none is found
 */
function llPrecedence(args) {
    args = args || {};
    const { precedence, defaultString, languageId } = args;
    var localizedLanguage = args.localizedLanguage || exports.languages[languageId || exports.defaultLanguageId];
    var showLocalizationWarnings = args.showLocalizationWarnings !== undefined
        ? args.showLocalizationWarnings
        : showLLPrecedenceWarnings;
    var key = _.find(precedence, function (s) {
        return !!localizedLanguage[s];
    });
    if (key) {
        return localizedLanguage[key];
    }
    if (showLocalizationWarnings) {
        llMissing(defaultString);
    }
    return defaultString;
}
exports.llPrecedence = llPrecedence;
exports.isRTL = (languageId) => {
    const rtlLanguages = ["ar", "fa", "ur", "he"];
    let result = false;
    rtlLanguages.forEach((lang) => {
        if (languageId.startsWith(lang)) {
            result = true;
        }
    });
    return result;
};
//# sourceMappingURL=ll.js.map